export const fileTypes = [
  { type: 'ttn', label: 'ТТН' },
  { type: 'tn', label: 'Транспортная накладная' },
  { type: 'act', label: 'Акт выполненных робот' },
  { type: 'unknown', label: 'Неизвестный тип файла' },
  { type: 'copy', label: 'Копия существующего документа' },
]

export const components = [
  'ttn-file-type',
  'ttn-file-type',
  '',
  'unknown-or-copy',
  'unknown-or-copy',
]

export const getVariants = type => variants[type]

const variants = {
  ttn: [
    { label: 'Лицевая', val: 'front' },
    { label: 'Оборотная', val: 'back' },
  ],
  tn: [
    { label: 'Лицевая', val: 'frontTn' },
    { label: 'Оборотная', val: 'backTn' },
  ],
}

export const sortMode = [
  {
    value: '-created_at',
    label: 'от новых к старым',
  },
  {
    value: 'created_at',
    label: 'от старых к новым',
  },
]
